<form [formGroup]="formGroup">
  <div class="grid-container margin-top">
    <div class="grid-x">
      <div [hidden]="organizationSelected" class="cell large-12 bold red">
        Please select an organization from the grid below.
      </div>
      <div [hidden]="organizationSelected" class="cell large-12">
        <ag-grid-angular class="data-grid " [gridOptions]="organizationGridOptions" [rowData]="organizations" [selectionColumnDef]="selectionColumnDef" (selectionChanged)="organizationChanged($event)" aria-label="Contact History Report"></ag-grid-angular>
      </div>
      <div [hidden]="!organizationSelected" class="cell large-3 medium-3 small-12 text-align-center padding-right">
        For Organization:
      </div>
      <div [hidden]="!organizationSelected" class="cell large-3 medium-3 small-6">
        {{ formGroup.get("organization")?.value }}
      </div>
      <div [hidden]="!organizationSelected" class="cell large-6 medium-6 small-6 padding-left-large">
        <button class="button" (click)="resetOrganization()">Select New Organization</button>
      </div>
      <div [hidden]="!organizationSelected" class="cell large-12 medium-12 small-12">
        <report-command [dateRequired]="true" [fromDate]="fromDate" [toDate]="toDate" [runText]="runText" (reportGenerated)="generateReport($event)" (reportDownloaded)="downloadReport($event)"></report-command>
      </div>
      @for (option of agentTypes; track option) {
        <div [hidden]="!organizationSelected" class="cell large-4 medium-4 small-6 padding-left">
          <div class="checkbox">
            <input class="show-for-sr" [id]="option.id" type="checkbox" [formControlName]="option.text" />
            <label [for]="option.id">
              <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>  {{option.text}}
            </label>
          </div>
        </div>
      }
      <div class="cell large-12 medium-12 small-12 padding-top">
        <ag-grid-angular [hidden]="!organizationSelected" class="data-grid " [gridOptions]="gridOptions" [rowData]="data" [excelStyles]="excelStyles" aria-label="Contact History Report"></ag-grid-angular>
      </div>
    </div>
  </div>
</form>
